export default __webpack_public_path__ + "static/media/info.08c164fc.png";